var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inward"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading || _vm.isLoadingNew
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('fieldset', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Box Packing")]), _vm._v(" "), (_vm.flag) ? _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('span', {
    staticClass: "clientnamecss"
  }, [_vm._v("Client Name : "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(this.clientname))])])]) : _vm._e(), _vm._v(" "), (_vm.showButtonManualPacking) ? _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('span', {
    staticClass: "testing"
  }, [_vm._v("Manual Packing")]), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "size": "sm",
      "id": "manualPackingEnable",
      "type": "checkbox"
    },
    on: {
      "change": _vm.manualPackingEnable
    }
  }), _c('span', {
    staticClass: "slider round"
  })])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Box ID")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cubes'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxid')
    },
    attrs: {
      "type": "text",
      "placeholder": "Box ID",
      "name": "boxid",
      "id": "boxid"
    },
    model: {
      value: (_vm.addbox.boxid),
      callback: function($$v) {
        _vm.addbox.boxid = $$v
      },
      expression: "addbox.boxid"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxid')),
      expression: "errors.has('boxid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('boxid')) + "\n                  ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Box Weight (in Kg)")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxweight')
    },
    attrs: {
      "type": "text",
      "value": "0",
      "name": "boxweight",
      "id": "boxweight"
    },
    model: {
      value: (_vm.addbox.boxweight),
      callback: function($$v) {
        _vm.addbox.boxweight = $$v
      },
      expression: "addbox.boxweight"
    }
  }), _vm._v(" "), _vm._v("\n                      "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getweight
    }
  }, [_c('i', {
    staticClass: "fa fa-cube"
  }), _vm._v(" Get Weight")])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxweight')),
      expression: "errors.has('boxweight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('boxweight')))])], 1)], 1), _vm._v(" "), (!_vm.isUnicommerce && !_vm.isWmall && _vm.isMultiseller) ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "id": "submitbtn",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.getBoxDetails(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Get Box Details")]), _vm._v("   \n                    "), (_vm.isMultiseller && _vm.showLabelsButtons) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.getInvoiceAndLabelFlipkart(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" Print\n                      Invoice")]) : _vm._e(), _vm._v("   \n                    "), (_vm.isMultiseller && _vm.showLabelsButtons) ? _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.getInvoiceAndLabelFlipkart(2)
      }
    }
  }, [_c('i', {
    staticClass: "ffa fa-envelope-o"
  }), _vm._v(" Print Label")]) : _vm._e(), _vm._v(" \n                  ")])], 1), _vm._v(" "), (_vm.shipmentPrintNotAvailable == false) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.shipmentPrintNotAvailableMSG))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isUnicommerce && !_vm.isWmall && !_vm.isMultiseller) ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "id": "submitbtn",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.getBoxDetails(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Get Box Details")]), _vm._v("   \n                    "), (_vm.isUnicommerce && _vm.showLabelsButtons) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.printLabelUnicommerce(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" Print\n                      Invoice")]) : _vm._e(), _vm._v("   \n                    "), (_vm.isUnicommerce && _vm.showLabelsButtons) ? _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.printLabelUnicommerce(2)
      }
    }
  }, [_c('i', {
    staticClass: "ffa fa-envelope-o"
  }), _vm._v(" Print Label")]) : _vm._e(), _vm._v(" \n                  ")])], 1), _vm._v(" "), (_vm.shipmentPrintNotAvailable == false) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.shipmentPrintNotAvailableMSG))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isWmall && !_vm.isUnicommerce && !_vm.isMultiseller) ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "id": "submitbtn",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.getBoxDetails(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Get Box Details")]), _vm._v("   \n                    "), (_vm.isWmall && _vm.showLabelsButtons) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.printLabelWmall(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" Print\n                      Invoice")]) : _vm._e(), _vm._v("   \n                    "), (_vm.isWmall && _vm.showLabelsButtons) ? _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.printLabelWmall(2)
      }
    }
  }, [_c('i', {
    staticClass: "ffa fa-envelope-o"
  }), _vm._v(" Print Label")]) : _vm._e(), _vm._v(" \n                  ")])], 1), _vm._v(" "), (_vm.shipmentPrintNotAvailable == false) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.shipmentPrintNotAvailableMSG))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isUnicommerce && !_vm.isWmall && !_vm.isMultiseller) ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "id": "submitbtn",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.getBoxDetails(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Get Box Details")]), _vm._v("   \n                    "), ((_vm.shipmentPrintNotAvailable == true || _vm.printInvoiceEnable == true) && !_vm.btnDisable && !_vm.isUnicommerce && !_vm.isWmall && _vm.showLabelsButtons && !_vm.xbIntegration) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "id": "invoicebutton",
      "size": "sm",
      "variant": "success",
      "disabled": _vm.btnDisable
    },
    on: {
      "click": _vm.PrintInvoiceAgaintsClient
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" Print\n                      Invoice")]) : _vm._e(), _vm._v("   \n                    "), (_vm.showLabelsButtons && _vm.shipmentPrintNotAvailable == true || _vm.printLabelEnable == true && !_vm.isUnicommerce && !_vm.isWmall) ? _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.PrintLabelAgaintsClient
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" Print\n                      Label")]) : _vm._e(), _vm._v(" \n                  ")])], 1), _vm._v(" "), (_vm.shipmentPrintNotAvailable == false) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.shipmentPrintNotAvailableMSG))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.flag2) ? _c('div', {
    staticClass: "col-lg-6",
    staticStyle: {
      "max-width": "30%"
    }
  }, [_c('label', [_vm._v("Status:\n                  "), (_vm.shipmentPrintNotAvailable == true) ? _c('span', {
    staticStyle: {
      "font-weight": "800",
      "color": "green",
      "margin": "10px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.shipmentStatus) + "\n                  ")]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('fieldset', [_c('br')])])], 1)]), _vm._v(" "), (_vm.showboxdetails) ? _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [(_vm.shipByDate) ? _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("Ship By Date :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.dateFormatDetail(_vm.shipByDate)))])]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('br'), _vm._v(" "), _c('label', [_vm._v("Order ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-cart '></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.addbox.orderid),
      callback: function($$v) {
        _vm.addbox.orderid = $$v
      },
      expression: "addbox.orderid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('br'), _vm._v(" "), _c('label', [_vm._v("Sales channel")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-first-order'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.addbox.seller),
      callback: function($$v) {
        _vm.addbox.seller = $$v
      },
      expression: "addbox.seller"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('br'), _vm._v(" "), _c('label', [_vm._v("Courier Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addbox.couriername),
      expression: "addbox.couriername"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('couriername')
    },
    attrs: {
      "name": "couriername",
      "id": "couriername"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addbox.couriername = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.CourierSelected]
    }
  }, _vm._l((_vm.addbox.saleschannel), function(courier_obj) {
    return _c('option', {
      domProps: {
        "value": courier_obj.courierid
      }
    }, [_vm._v(_vm._s(courier_obj.couriername))])
  }))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('couriername')),
      expression: "errors.has('couriername')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('couriername')))])], 1)], 1), _vm._v(" "), (!_vm.xbcheck) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('br'), _vm._v(" "), _c('label', [_vm._v("AWB No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbno')
    },
    attrs: {
      "readonly": (_vm.isrubiconshipment == true && _vm.addbox.couriername != 'Amazon') || _vm.isUnicommerce == true || _vm.isWmall == true || _vm.xbIntegration == true,
      "type": "text",
      "name": "awbno",
      "id": "awbno"
    },
    model: {
      value: (_vm.addbox.awbno),
      callback: function($$v) {
        _vm.addbox.awbno = $$v
      },
      expression: "addbox.awbno"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('awbno')),
      expression: "errors.has('awbno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('awbno')) + "\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.showboxdetails) ? _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Total SKU")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Total Quantity")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Total Cancelled")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(_vm._s(_vm.totalsku))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(_vm._s(_vm.totalquantity))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.cancel))])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.showboxdetails) ? _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Total QC Accepted Qty")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Total QC Rejected Qty")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(_vm._s(_vm.qcacceptqty))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_c('p', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.qcrejectqty))])])])])])])]) : _vm._e()]), _vm._v(" "), (_vm.minisocheck) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Volumetric Weight :-")])]) : _vm._e(), _vm._v(" "), (_vm.minisocheck) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<b>L</b>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Length",
      "type": "number",
      "step": "0.01",
      "min": "0.1"
    },
    model: {
      value: (_vm.boxl),
      callback: function($$v) {
        _vm.boxl = $$v
      },
      expression: "boxl"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.minisocheck) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<b>B</b>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Breadth",
      "type": "number",
      "step": "0.01",
      "min": "0.1"
    },
    model: {
      value: (_vm.boxb),
      callback: function($$v) {
        _vm.boxb = $$v
      },
      expression: "boxb"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.minisocheck) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<b>H</b>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Enter Height",
      "type": "number",
      "step": "0.01",
      "min": "0.1"
    },
    model: {
      value: (_vm.boxh),
      callback: function($$v) {
        _vm.boxh = $$v
      },
      expression: "boxh"
    }
  })], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.cancel > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', [_vm._v("Cancelled Quantity Details")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Product Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Productid")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Rack ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Quantity")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Picked Quantity")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Cancelled Quantity")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.canceldetails), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rackid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.pickqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.cancelqty))])])
  }), _vm._v(" "), (_vm.canceldetails.length < 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])]) : _vm._e()])]), _vm._v(" "), _c('b-card', [(_vm.showQCSection) ? _c('div', {
    staticClass: "form-group row"
  }, [(!_vm.showSpilitDeatils) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Scan Product ID : ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productid),
      expression: "productid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Product ID",
      "name": "productid",
      "id": "productid"
    },
    domProps: {
      "value": (_vm.productid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productid = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isscanproducterror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.scanproducterror))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(!_vm.showSpilitDeatils) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "-64px"
    },
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.scanProduct
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Scan")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showproductdetails) ? _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Product Image")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Product Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("brand")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("size")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("color")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("mrp")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("productcategory")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("productdescription")])])])]), _vm._v(" "), _c('tbody', [(_vm.scanproductData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "8",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), (_vm.scanproductData.length != 0) ? _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.scanproductData.productimage,
      "width": "100px",
      "height": "120px"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.scanproductData.productname))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.scanproductData.brand))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.scanproductData.size))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.scanproductData.color))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.scanproductData.mrp))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.scanproductData.productcategory))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.scanproductData.productdescription))])]) : _vm._e()])])]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.showproductdetailsbtn) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right",
      "margin-right": "-4px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.ProductDetails('accept')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Accept")]), _vm._v("  \n            "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.RejectProductDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reject")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "text-align": "center !IMPORTANT"
    }
  }, [(_vm.fullErrorMessage != '') ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('span', {
    staticStyle: {
      "text-align": "center !IMPORTANT"
    }
  }, [_vm._v(_vm._s(_vm.fullErrorMessage) + ".")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  })]), _vm._v(" "), (_vm.showSpilitDeatils) ? _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "-50px"
    }
  }, [_c('fieldset', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "margin-left": "14px"
    }
  }, [_vm._v("Source Box Details")])])])]) : _vm._e(), _vm._v(" "), (_vm.showSpilitDeatils) ? _c('div', {
    staticStyle: {
      "overflow-x": "auto",
      "height": "147px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Source Box ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Product ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Product Eancode")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Product Quantity")])])])]), _vm._v(" "), _c('tbody', [(_vm.spiltdetalsdata.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "8",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.spiltdetalsdata), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.boxid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productqty))])])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showSpilitDeatils && _vm.spiltDestinationdata.length > 0) ? _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "-70"
    }
  }, [_c('fieldset', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "margin-left": "14px"
    }
  }, [_vm._v("Destination Box Details")])])])]) : _vm._e(), _vm._v(" "), (_vm.showSpilitDeatils && _vm.spiltDestinationdata.length > 0) ? _c('div', {
    staticStyle: {
      "overflow-x": "auto",
      "height": "147px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%",
      "overflow": "auto"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Destination Box ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Product ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Product Eancode")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Product Quantity")])])])]), _vm._v(" "), _c('tbody', [(_vm.spiltDestinationdata.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "8",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.spiltDestinationdata), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.boxid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productqty))])])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showSpilitDeatils) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Destination Box ID:"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addspilitbox.spilitBoxID),
      expression: "addspilitbox.spilitBoxID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxid')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Box ID",
      "name": "boxid",
      "id": "boxid"
    },
    domProps: {
      "value": (_vm.addspilitbox.spilitBoxID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addspilitbox.spilitBoxID = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxid')),
      expression: "errors.has('boxid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('boxid')) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "-64px"
    },
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.validateSpiltBoxID
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Validate Box")])])]) : _vm._e(), _vm._v(" "), (_vm.showSpilitDeatils) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.errorofsplitbox) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Destination Product ID/Eancode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addspilitbox.productid),
      expression: "addspilitbox.productid"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('productid')
    },
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Enter Product ID",
      "name": "productid",
      "id": "productid"
    },
    domProps: {
      "value": (_vm.addspilitbox.productid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addspilitbox.productid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('productid')),
      expression: "errors.has('productid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('productid')) + "\n                ")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('br'), _vm._v(" "), (_vm.isComplete1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "id": "submitbtn",
      "disabled": !_vm.isComplete1,
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.addSpiltBox
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Add Split Box")]) : _vm._e(), _vm._v("   \n\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('br'), _vm._v("   \n              "), (_vm.isComplete1) ? _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-left": "-44px"
    },
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetSpiltBox
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showButton) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right",
      "margin-top": "51px",
      "margin-right": "-7px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "id": "submitbtn",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.confirmationmodal
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Packing Completed")]), _vm._v("  \n            "), (_vm.totalquantity > 1) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.SpiltBoxModal
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Split Box")]) : _vm._e(), _vm._v("  \n\n            "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])]) : _vm._e(), _vm._v(" "), (_vm.isRejectReason) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-left": "-15px"
    }
  }, [_c('label', [_vm._v("Reject Reasons :")])]) : _vm._e(), _vm._v(" "), (_vm.isRejectReason) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "id": "reason1",
      "value": "Size mismatched"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "Size mismatched") > -1 : (_vm.checkedNames)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Size mismatched",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('span', {
    attrs: {
      "for": "Size mismatched"
    }
  }, [_vm._v("Size mismatched")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "id": "reason2",
      "value": "Color mismatched"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "Color mismatched") > -1 : (_vm.checkedNames)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Color mismatched",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('span', {
    attrs: {
      "for": "Color mismatched"
    }
  }, [_vm._v("Color mismatched")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "id": "reason3",
      "value": "MRP mismatched"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "MRP mismatched") > -1 : (_vm.checkedNames)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "MRP mismatched",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('span', {
    attrs: {
      "for": "MRP mismatched"
    }
  }, [_vm._v("MRP mismatched")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "id": "reason4",
      "value": "Other"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "Other") > -1 : (_vm.checkedNames)
    },
    on: {
      "click": _vm.checkOtherReason,
      "__c": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Other",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('span', {
    attrs: {
      "for": "Other"
    }
  }, [_vm._v("Other")])])], 1), _vm._v(" "), (_vm.isOtherReason) ? _c('div', {
    staticClass: "col-md-4 test"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherreason),
      expression: "otherreason"
    }],
    staticClass: "effect-1",
    attrs: {
      "type": "text",
      "placeholder": "Enter Reason",
      "name": "OtherReason"
    },
    domProps: {
      "value": (_vm.otherreason)
    },
    on: {
      "keyup": _vm.clearerror,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherreason = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isOtherReason) ? _c('span', {
    staticClass: "focus-border"
  }) : _vm._e(), _vm._v(" "), (_vm.isCheckboxError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.Checkboxerrors))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isRejectReason) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right",
      "margin-right": "-4px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.saveRejectReason
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v("  \n            "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.cancelReason
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.showboxdetails && _vm.showOrderDetails) ? _c('div', [_c('b-card', [_c('fieldset', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Box UnPacking")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Box ID: " + _vm._s(this.addbox.boxid) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-left": "-171px"
    },
    attrs: {
      "disabled": !_vm.isComplete2,
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.Unpackboxid(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Unpackage")]), _vm._v(" \n\n            ")])])])])], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    staticClass: "confirmation",
    attrs: {
      "size": "lm",
      "title": _vm.$t('boxList.packingBox'),
      "title": "UnPacking Box"
    },
    model: {
      value: (_vm.UnpackBoxid),
      callback: function($$v) {
        _vm.UnpackBoxid = $$v
      },
      expression: "UnpackBoxid"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Unpacking Box")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.UnpackBoxid = false;
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Do you want to Unpack Box ID " + _vm._s(this.addbox.boxid) + "?")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-left": "324px",
      "margin-top": "-67px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.unpackageboxid
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-top": "-67px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.UnpackBoxid = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" No")])])])])]), _vm._v(" "), (!_vm.showboxdetails && _vm.showOrderDetails) ? _c('div', [_c('b-card', [_c('fieldset', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Order Details")])]), _vm._v(" "), (!_vm.showboxdetails && _vm.showOrderDetails) ? _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Order ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipment ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sales Channel")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Box Product Quantity")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Order Quantity")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping Company")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("AWB No")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.orderDetails.orderid))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [(_vm.orderDetails.shipmentid != "") ? _c('span', [_vm._v(_vm._s(_vm.orderDetails.shipmentid))]) : _vm._e(), _vm._v(" "), (_vm.orderDetails.shipmentid == "") ? _c('span', [_vm._v("-")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [(_vm.orderDetails.saleschannel != "") ? _c('span', [_vm._v(_vm._s(_vm.orderDetails.saleschannel))]) : _vm._e(), _vm._v(" "), (_vm.orderDetails.saleschannel == "") ? _c('span', [_vm._v("-")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [(_vm.orderDetails.boxproductqty != "") ? _c('span', [_vm._v(_vm._s(_vm.orderDetails.boxproductqty))]) : _vm._e(), _vm._v(" "), (_vm.orderDetails.boxproductqty == "") ? _c('span', [_vm._v("-")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [(_vm.orderDetails.Orderqty != "") ? _c('span', [_vm._v(_vm._s(_vm.orderDetails.Orderqty))]) : _vm._e(), _vm._v(" "), (_vm.orderDetails.Orderqty == "") ? _c('span', [_vm._v("-")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [(_vm.orderDetails.shippingcompany != "") ? _c('span', [_vm._v(_vm._s(_vm.orderDetails.shippingcompany))]) : _vm._e(), _vm._v(" "), (_vm.orderDetails.shippingcompany == "") ? _c('span', [_vm._v("-")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [(_vm.orderDetails.awbno != "") ? _c('span', [_vm._v(_vm._s(_vm.orderDetails.awbno))]) : _vm._e(), _vm._v(" "), (_vm.orderDetails.awbno == "") ? _c('span', [_vm._v("-")]) : _vm._e()])])])])]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.cancelmodalShow),
      callback: function($$v) {
        _vm.cancelmodalShow = $$v
      },
      expression: "cancelmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatuscancelModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('label', [_vm._v(" Please RackIn Cancelled Products ")])]), _vm._v("\n                         \n              "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n                                                    \n                "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.yescancelmodal()
      }
    }
  }, [_vm._v("Yes")]), _vm._v("\n                 "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "size": "sm",
      "variant": "secondary"
    },
    on: {
      "click": _vm.closeStatuscancelModal
    }
  }, [_vm._v("No")])])])])])])])], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-719c7c40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-719c7c40","hasScoped":true}!./src/views/components/packing/packing.component.html
// module id = 1330
// module chunks = 0